import styled from "styled-components";

const CloseButton = styled.button`
  display: flex;
  align-items: center;

  background: none;
  border: none;
  cursor: pointer;
  margin-right: 16px;

  && img {
    width: 24px;
    height: 24px;
  }
`;

export default CloseButton;
